<template>
  <v-app id="inspire"> 
     <v-app-bar
    id="app-bar"
    fixed
    clipped-left
    app
    color="darken-3"
    dark 
    dense
    height="64"  
  > 
    <v-app-bar-nav-icon 
      medium
      class="pl-10"
      color="white darken-1" 
    ><v-img src="/ntsa.png" height="60" width="100"/></v-app-bar-nav-icon>   

    <v-spacer></v-spacer>   

    <router-link to="/ntsa">
    <v-btn
      class="ml-2"
      color="white" 
      min-width="0" 
      text> 
      <v-icon medium>mdi-alert-outline</v-icon> Viewer
    </v-btn> 
    </router-link>
 
   <router-link to="/violations"> 
    <v-btn
      class="ml-2"
      color="white" 
      min-width="0" 
      text> 
      <v-icon medium>mdi-alert-outline</v-icon> Violations Report
    </v-btn> 
    </router-link>

    <v-btn
      class="ml-2"
      color="white"
      @click="logout" 
      min-width="0"
      text
    >
      <v-icon medium>mdi-exit-to-app</v-icon> Sign Out
    </v-btn> 
    <br />
  </v-app-bar>

  <div style="min-height:610px; background: #eee; margin-top: 48px; padding: 5px"  class="mobile_content">  
    <v-toolbar light color="white" class="pt-4 mt-4"> 
          <br>
          <br>
          <br>  
          <br>
          <v-row >  
            <v-col cols="4"><v-datetime-picker label="From Datetime" v-model="from_date"> </v-datetime-picker> </v-col>   
            <v-col cols="4"><v-datetime-picker title="false" label="To Datetime" v-model="date"> </v-datetime-picker> </v-col>  
            <v-col cols="3"> <v-btn   outlined class="px-1 mx-2" color="blue" small> <v-icon>mdi-calendar</v-icon> Apply Filter &nbsp;</v-btn></v-col>
          </v-row>     
        </v-toolbar>   
 
    <v-container id="green lighten-3" fluid tag="section">

        <div v-if="!fetching_data && violations.length==0">
              <br>
             <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
               <div class="display-1  font-weight-light">No violations data is available. (sthe date range and click on the calendar button to fetch records.)</div> 
               </v-alert>  
        </div>


        <v-simple-table class="pa-2" v-if="!fetching_data && violations.length>0">
              <template v-slot:default>
                <thead> 
                  <tr> 
                    <th class="text-left"> Registration </th>  
                    <th class="text-left"> Date </th> 
                    <th class="text-left"> Speed </th> 
                    <th class="text-left"> Violation</th>  
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(drive,i) in filterrable(violations)" :key="i">
                    <td>{{ drive.reg }}</td>  <td>{{ drive.date }}</td>  <td>{{drive.speed}} </td>  <td>{{ drive.violation }}</td>
                  </tr>
                </tbody>
              </template>
        </v-simple-table> 
        <v-pagination v-model="page" v-if="violations.length>page_size" :length="round(violations.length/page_size)"></v-pagination>
    </v-container> 
  </div>  
  <Footer /> 
  </v-app>
</template>

<script>
import moment from "moment"; 
import common from "./mixins/common";
import DatetimePicker from 'vuetify-datetime-picker' 
import vue from "vue"; 
vue.use(DatetimePicker)

export default {
  name: "Violations",  
  mixins: [common], 
  data() {
    return {
      top_dash: [],
      m_notification: [],
      violations: [], 
      trip_alert_data: [], 
      from_date: moment().subtract(7,'days').format("YYYY-MM-DD HH:mm"),  
      date: moment().format("YYYY-MM-DD HH:mm"), 
      fetching_data: false,
      fetching_trip: false,
      hasreset : false,
      page: 1, 
      page_size: 10,
      menu: false,
      downloading: false,
      menuu: false,
      modal: false,
      tabs: null, 
      selected_object:  '',
      stopage: 1
    };
  },
  created() {
    // this.available_data();
  }, 
  methods: {
    filterrable(array){ 
      var new_array = [];  
      for(var i = this.page_size * (this.page -1); i < this.page * this.page_size; i++ ){
        if(i>=array.length)
          break;
        new_array.push(array[i]); 
      } 
      return new_array;
    },
    round(data){
      return Math.ceil(data);
    },
    init(){ 
      this.available_data();
    },   
 
 
    available_data() {    
      this.http_connect("/violations", {
        token: this.check_token(),
        dtf: this.from_date,
        dtt: this.date
      })
        .then(res => { 
          if (res.status == 200) {   
            this.trip_alert_data = [];  
            res.data.map(data =>{
              data.map(h=> {
                this.trip_alert_data.push({lat: h[2],lng: h[3],speed: h[6],engineon: true,current_loc: h[8],dt_tracker: h[1] ,reg: h[9],desc: h[0]});
              }); 
            });  
          }
        })
        .catch(err => {});
    }
  },
  computed: {
      dateRangeText () {
        return this.dates.join(' to ')
      }, 
    },
};
</script>

<style scoped>
#dashboard,
template {
  background: #eee;
}
</style>
